import apiService from './ApiService';

export default class MessageTemplateApiService {
    /**
     * Gets every message template the owner is allowed to edit, with its current wording.
     * @returns {Promise<ServiceResponse<Array>>}
     */
    async getEditableTemplates() {
        const response = await apiService.getData('api/MessageTemplate');
        return response?.data;
    }

    /**
     * Saves new wording for one template.
     * @param template {{channel: number, key: string, subject: string, body: string}}
     * @returns {Promise<ServiceResponse<object>>}
     */
    async updateTemplate(template) {
        const response = await apiService.putData('api/MessageTemplate', template);
        return response?.data;
    }
}
